module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pr-28689af1c71936396dba280aafdedbad.svg";